import React, { useState } from "react";
import { Checkbox, Input, Button, message, Typography, Row } from "antd";
import "./index.css";
import { rejectionReasonCall } from "../data/api";
import successImage from "../assets/success.png";
import { RejectionReasonsEnum } from "../utils/enums";

const reasonsList = [
  "I was already on an IVR call",
  "I received both an IVR and a video call simultaneously",
  "Other (please specify)"
];

type Props = {
  onSuccess?: () => void;
  callId: string;
  token: string;
  rejectionSource: RejectionReasonsEnum;
};

const RejectReasonForm: React.FC<Props> = ({
  onSuccess,
  callId,
  token,
  rejectionSource
}) => {
  const [selectedReason, setSelectedReason] = useState<string | null>(null);
  const [customReason, setCustomReason] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCheckboxChange = (reason: string) => {
    setSelectedReason(reason);
    if (reason !== "Other (please specify)") {
      setCustomReason("");
    }
  };

  const handleSubmit = async () => {
    if (!selectedReason) {
      message.warning("Please select a reason");
      return;
    }

    if (
      selectedReason === "Other (please specify)" &&
      customReason.trim() === ""
    ) {
      message.warning("Please provide a reason in the text area");
      return;
    }

    const reasonTextRaw =
      selectedReason === "Other (please specify)"
        ? customReason.trim()
        : selectedReason;

    const prefix =
      rejectionSource === RejectionReasonsEnum.CANCELLED_CALL
        ? "cancelled"
        : "missed";
    const reasonText = `${prefix}-${reasonTextRaw}`;

    try {
      setLoading(true);
      const result = await rejectionReasonCall(callId, reasonText, token);
      if (result.success) {
        setSubmitted(true);
        setTimeout(() => {
          onSuccess?.();
        }, 2500);
      } else {
        message.error(result.message);
      }
    } catch (error) {
      message.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="reject-reason-success">
        <div className="reject-reason-icon">
          <img src={successImage} />
        </div>
        <h3>
          Thank you for sharing <br /> your response
        </h3>
        <p>We’ll make a note of it!</p>
      </div>
    );
  }

  return (
    <>
      <div className="reject-reason-form">
        {/* <p>{callId}</p> */}
        <p className="reject-reason-heading">
          Please select the reason for not answering / rejecting the patient
          call?
        </p>
        <div className="reject-reason-title">
          {reasonsList.map((reason) => (
            <Row key={reason} align="middle" className="reason-row">
              <Checkbox
                checked={selectedReason === reason}
                onChange={() => handleCheckboxChange(reason)}
                className="custom-checkbox"
              />
              <span className="reason-text">{reason}</span>
            </Row>
          ))}

          {selectedReason === "Other (please specify)" && (
            <Input.TextArea
              className="reject-reason-textarea"
              placeholder="Type your reason here..."
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
              rows={3}
            />
          )}
        </div>
        <Button
          type="primary"
          onClick={handleSubmit}
          disabled={!selectedReason}
          loading={loading}
          className="reject-reason-submit"
        >
          <Typography.Text style={{ color: "white" }}>Submit</Typography.Text>
        </Button>
      </div>
    </>
  );
};

export default RejectReasonForm;
